import { render, staticRenderFns } from "./incometaxProofApproval.vue?vue&type=template&id=3f689583&scoped=true"
import script from "./incometaxProofApproval.vue?vue&type=script&lang=js"
export * from "./incometaxProofApproval.vue?vue&type=script&lang=js"
import style0 from "./incometaxProofApproval.vue?vue&type=style&index=0&id=3f689583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f689583",
  null
  
)

export default component.exports